(function (Drupal, drupalSettings) {
  Drupal.behaviors.anchors = {
    attach: (context, settings) => {
      if (context === document) {
        const anchorsCheckReadyState = setInterval(() => {
          // BigPipe may cause this block to be called too early, wait for readyState complete.
          if (document.readyState === 'complete') {
            clearInterval(anchorsCheckReadyState);
            (function ($) {
              if (document.body.getAttribute('data-anchors') === 'true') {
                return;
              }
              enableAnchors();
              document.body.setAttribute('data-anchors', 'true');
            }(jQuery));
          }
        }, 100);
      }
    }
  };

  /**
   * Build the anchor navigation.
   *
   * @return {void};
   */
  function enableAnchors() {
    const anchorNav = document.getElementById('anchors');
    if (!anchorNav) {
      return;
    }

    // Content wrapper.
    const content    = document.querySelector('.basic-page');
    const anchorList = document.getElementById('anchor-list');
    const menuAuto = document.querySelector('.header__anchors--auto');

    // Get headings.
    const anchorTarget = [
      'h1',
      '.donation-need h2',
      '.image-and-text .image-and-text__titre',
      '.bone-marrow-sample h2',
      '.great-standard h2',
      '.region-events h2',
      '.texte-image-2-colonnes h2',
      '.video',
      '.testimonials-to-share',
      '.filter-nav',
    ];
    const anchorSelector = anchorTarget.join(',');
    let headingList = content.querySelectorAll(anchorSelector);

    // Convert NodeList to an array.
    headingList = Array.prototype.slice.call(headingList);

    activeAnchorLinks(headingList);

    if (!headingList.length) {
      anchorList.innerHTML = '<li>Aucune ancre</li>';
      return;
    }

    // Create anchors.
    let i = 0;
    [].forEach.call(headingList, (heading) => {
      let anchorText = heading.textContent;
      // Remove space & empty lines.
      anchorText = anchorText.trim();

      if (!anchorText) {
        return;
      }

      // Add id on headings.
      let id = heading.classList.item(0).replace('__titre', '');
      id = `anchor-${id}`;
      if (document.getElementById(id)) {
        id += `-${i + 1}`;
      }

      // Add the id on the headings.
      heading.setAttribute('id', id);

      if (menuAuto) {
        // Generate link toward the anchor.
        const link = document.createElement('a');
        link.setAttribute('href', `#${id}`);
        link.textContent = anchorText;

        const li = document.createElement('li');

        // Active the first link.
        if (i === 0) {
          link.classList.add('anchor--is-active');
          li.classList.add('anchor-parent--is-active');
        }

        li.appendChild(link);
        anchorList.appendChild(li);
      }

      i++;
    });

    if (!anchorList) {
      return;
    }

    if (!menuAuto) {
      // Active the first link.
      anchorList.querySelector('li:first-child').classList.add('anchor-parent--is-active');
      anchorList.querySelector('li:first-child a').classList.add('anchor--is-active');
    }

    // Smooth scrool.
    const anchorItemList = anchorList.querySelectorAll('a');
    [].forEach.call(anchorItemList, (link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const a = link;
        const headerOffset = 200;
        let anchorId = a.getAttribute('href');
        anchorId = anchorId.substring(1, anchorId.length);
        const anchor = document.getElementById(anchorId);
        const bodyRect = document.body.getBoundingClientRect().top;
        const anchorOffset =  anchor.getBoundingClientRect().top - bodyRect - headerOffset;
        const anchorBlock = document.getElementById('anchor-list');

        // Toggle menu on small screens.
        if (window.matchMedia('(max-width: 1365px)').matches && a.classList.contains('anchor--is-active')) {
          anchorBlock.classList.toggle('anchors--are-expanded');
        } else {
          // Collapse menu.
          anchorBlock.classList.remove('anchors--are-expanded');

          // Smooth.
          window.scroll({
            top: anchorOffset,
            left: 0,
            behavior: 'smooth',
          });
        }
      });
    });
  }

  /**
   * Determine if the specified DOM object is in the viewport.
   *
   * @param {Object} el - DOM object
   * @returns {Bool} True if element is in the viewport.
   */
  function isInViewport(el) {
    const bounding = el.getBoundingClientRect();
    const viewportRatio = 0.5;

    // is above.
    if (bounding.top + bounding.height <= 0) {
      return false;
    }

    const screenHeight = window.innerHeight || document.documentElement.clientHeight;

    // is bellow.
    if (bounding.top > screenHeight * viewportRatio) {
      return false;
    }

    // is in the viewport.
    return true;
  }

  /**
   * Highlight the current anchor.
   *
   * @param {NodeList} headingList
   *  Set of headings.
   *
   * @return {void};
   */
  function activeAnchorLinks(headingList) {
    window.addEventListener('scroll', (e) => {
      const anchorBlock = document.getElementById('anchor-list');

      if (window.matchMedia('(max-width: 1365px)').matches) {
        anchorBlock.classList.remove('anchors--are-expanded');
      }

      [].forEach.call(headingList, (heading) => {
        if (isInViewport(heading)) {
          const id = heading.getAttribute('id');
          const matchingLink = document.querySelector(`#anchor-list a[href="#${id}"]`);


          // Remove the active state.
          if (matchingLink) {
            const anchorList = document.querySelectorAll('#anchor-list a');
            [].forEach.call(anchorList, (anchor) => {
              anchor.classList.remove('anchor--is-active');
              anchor.parentNode.classList.remove('anchor-parent--is-active');
            });

            matchingLink.classList.add('anchor--is-active');
            matchingLink.parentNode.classList.add('anchor-parent--is-active');
          }
        }
      });
    });
  }
}(Drupal, drupalSettings));
